import { format } from 'date-fns'
import { handleApiErrors } from 'utils/handleApiError'
import aroAPI from './config'
import { IFleetRoutes } from 'interface/map'
import { Iregionlist } from 'interface'

const fetchFleetRoutes = async (office_id: number, date: Date) => {
  try {
    const response = await aroAPI.get('/tracking/fleet-routes', {
      params: {
        office_id: office_id.toString(),
        date: format(date, 'yyyy-MM-dd'),
      },
    })
    const { result }: IFleetRoutes = handleApiErrors(response)
    return result
  } catch (error: any) {
    handleApiErrors(error.response)
  }
}

const fetchRegions = async () => {
  try {
    const response = await aroAPI.get('/tracking/regions')
    const { result }: Iregionlist = handleApiErrors(response)
    return result
  } catch (error: any) {
    handleApiErrors(error.response)
  }
}

export { fetchFleetRoutes, fetchRegions }
